import { HttpClient, HttpContext, HttpContextToken } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { Router } from '@angular/router';
import { Injectable, inject } from '@angular/core';

import { passwordLogin } from '../../../api/identity/fn/auth/password-login';
import { refreshToken } from '../../../api/identity/fn/auth/refresh-token';
import { LoginRequest } from '../../../api/identity/models/login-request';
import { LoginApiResponse } from '../../../api/identity/models/login-api-response';
import { StrictHttpResponse } from '../../../api/identity/strict-http-response';
import { getLoggedInUserDetails } from '../../../api/identity/fn/users/get-logged-in-user-details';
import { UserProfileResponse } from '../../../api/identity/models/user-profile-response';
import { IdentityApiConfiguration } from 'src/app/api/identity/identity-api-configuration';
import { getUserProfile } from 'src/app/api/administration/fn/users/get-user-profile';
import { GhUserProfileResponse } from 'src/app/api/administration/models/gh-user-profile-response';
import { AdministrationApiConfiguration } from 'src/app/api/administration/administration-api-configuration';

export const IS_REFRESH_TOKEN = new HttpContextToken<boolean>(() => false);

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(
    private http: HttpClient,
    private config: IdentityApiConfiguration,
    private adminConfig: AdministrationApiConfiguration,
    private router: Router
  ) {}

  getAccessToken(): string | null {
    return localStorage.getItem('access_token');
  }
  getRefreshToken(): string | null {
    return localStorage.getItem('refresh_token');
  }
  setAccessToken(token: string): void {
    localStorage.setItem('access_token', token);
  }
  setRefreshToken(token: string): void {
    localStorage.setItem('refresh_token', token);
  }
  removeAccessToken(): void {
    localStorage.removeItem('access_token');
  }

  isLoggedIn(): boolean {
    return !!localStorage.getItem('access_token');
  }
  logout(): void {
    localStorage.clear();
  }

  login(credentials: LoginRequest): Observable<StrictHttpResponse<LoginApiResponse>> {
    return passwordLogin(this.http, this.config.rootUrl, { body: credentials }).pipe(
      tap((response) => {
        const tokenData = response.body.data?.[0];
        if (tokenData) {
          if (tokenData.accessToken) {
            this.setAccessToken(tokenData.accessToken);
          }
          if (tokenData.refreshToken) {
            this.setRefreshToken(tokenData.refreshToken);
          }
        }
      })
    );
  }

  refreshToken(): Observable<StrictHttpResponse<LoginApiResponse>> {
    return refreshToken(
      this.http,
      this.config.rootUrl,
      {},
      new HttpContext().set(IS_REFRESH_TOKEN, true)
    ).pipe(
      tap((response) => {
        const tokenData = response.body.data?.[0];
        if (tokenData) {
          if (tokenData.accessToken) {
            this.setAccessToken(tokenData.accessToken);
          }
          if (tokenData.refreshToken) {
            this.setRefreshToken(tokenData.refreshToken);
          }
        }
      })
    );
  }

  getLoggedInUserDetails(): Observable<StrictHttpResponse<UserProfileResponse>> {
    return getLoggedInUserDetails(this.http, this.config.rootUrl);
  }

  getUserProfile(): Observable<StrictHttpResponse<GhUserProfileResponse>> {
    return getUserProfile(this.http, this.adminConfig.rootUrl);
  }
}
